import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/',
    component: () => import('@/layout/MainLayout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '数据概览', icon: 'el-icon-s-data' }
      },
      // 用户管理
      {
        path: 'users',
        name: 'UserManagement',
        component: () => import('@/views/UserManagement.vue'),
        meta: { title: '后台用户管理', icon: 'el-icon-user' }
      },
      // 小程序用户管理
      {
        path: 'mini-users',
        name: 'MiniUserManagement',
        component: () => import('@/views/MiniUserManagement.vue'),
        meta: { title: '小程序用户', icon: 'el-icon-mobile-phone' }
      },
      // 分类管理
      {
        path: 'category',
        name: 'CategoryManage',
        component: () => import('@/views/CategoryManage.vue'),
        meta: { title: '分类管理', icon: 'el-icon-folder-opened' }
      },
      // 产品分类管理
      {
        path: 'product-category',
        name: 'ProductCategoryManage',
        component: () => import('@/views/ProductCategoryManage.vue'),
        meta: { title: '产品分类', icon: 'el-icon-collection' }
      },
      // 素材管理
      {
        path: 'material',
        name: 'MaterialManage',
        component: () => import('@/views/MaterialManage.vue'),
        meta: { title: '素材管理', icon: 'el-icon-gem' }
      },
      // 商品管理
      {
        path: 'product',
        name: 'ProductManage',
        component: () => import('@/views/ProductManage.vue'),
        meta: { title: '商品管理', icon: 'el-icon-goods' }
      },
      // 订单管理
      {
        path: 'order',
        name: 'OrderManage',
        component: () => import('@/views/OrderManage.vue'),
        meta: { title: '订单管理', icon: 'el-icon-document' }
      },
      // 设计管理
      {
        path: 'design',
        name: 'DesignManage',
        component: () => import('@/views/DesignManage.vue'),
        meta: { title: '设计管理', icon: 'el-icon-edit' }
      },
      // 轮播图管理
      {
        path: 'banner',
        name: 'BannerManage',
        component: () => import('@/views/BannerManage.vue'),
        meta: { title: '轮播图管理', icon: 'el-icon-picture' }
      },
      // 首页入口管理
      {
        path: 'home-entry',
        name: 'HomeEntryManage',
        component: () => import('@/views/HomeEntryManage.vue'),
        meta: { title: '首页入口', icon: 'el-icon-menu' }
      },
      // 开屏广告管理
      {
        path: 'splash-ad',
        name: 'SplashAdManage',
        component: () => import('@/views/SplashAdManage.vue'),
        meta: { title: '开屏广告', icon: 'el-icon-monitor' }
      },
      // 系统配置
      {
        path: 'config',
        name: 'ConfigManage',
        component: () => import('@/views/ConfigManage.vue'),
        meta: { title: '系统配置', icon: 'el-icon-setting' }
      },
      // 优惠券管理
      {
        path: 'coupon',
        name: 'CouponManage',
        component: () => import('@/views/CouponManage.vue'),
        meta: { title: '优惠券管理', icon: 'el-icon-tickets' }
      },
      // 推广中心
      {
        path: 'promotion',
        name: 'PromotionManage',
        component: () => import('@/views/PromotionManage.vue'),
        meta: { title: '推广中心', icon: 'el-icon-share' }
      },
      // 钱包管理
      {
        path: 'wallet',
        name: 'WalletManage',
        component: () => import('@/views/WalletManage.vue'),
        meta: { title: '钱包管理', icon: 'el-icon-wallet' }
      },
      // 密码修改
      {
        path: 'change-password',
        name: 'ChangePassword',
        component: () => import('@/views/ChangePassword.vue'),
        meta: { title: '修改密码', icon: 'el-icon-lock' }
      }
    ]
  }
]

const router = new Router({
  routes
})

// 路由守卫
router.beforeEach((to, _from, next) => {
  const token = localStorage.getItem('token')

  if (to.path === '/login') {
    if (token) {
      next('/dashboard')
    } else {
      next()
    }
  } else {
    if (token) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js